module.exports = __webpack_public_path__ + "static/media/fly0118.b74648db.webp";